// Returns a list of units associated with the current user
// so the client can let the user switch between units

import axios from 'axios'
import { KMS_BACKEND } from '@/config'
import { handleServiceErrors } from '@/services/errors'
import auth from '@/services/_auth'

export async function getEnabledFeatures(hoaID) {
  //const options = { hoaID: hoaID, headers: { ...this.authHeaders() } }

  console.debug('in getEnabledFeatures...')

  const path = `${KMS_BACKEND}/Subscriptions/HoaFeature/GetEnabledFeatures?hoaID=${hoaID}`
  console.debug('path===' + path)

  return axios
    .get(path, {
      headers: { ...auth.authHeaders() }
    })
    .then(res => res.data.featureCodes)
    .catch(handleServiceErrors)
}
